<atlas-feature-management-buttons
  (featureManagementOptionSelected)="onFeatureManagementOptionSelected($event)"
  >
</atlas-feature-management-buttons>
<div class="feature-management-container">
  @if (featureManagementOption == 'Layers') {
    <atlas-layer-management
      class="layers-container"
    ></atlas-layer-management>
  }

  @if (featureManagementOption == 'LocatorLocations') {
    <atlas-library-locations-list
      class="layers-container"
      (locationsClickSelected)="onLocationClickSelected($event)"
      [libraryId]="libraryId$ | async"
      [selectedLocationId]="selectedLocationId$ | async"
    ></atlas-library-locations-list>
  }

  @if (isLocatorFeatureSelected$ | async) {
    @if(isVisible$ | async ) {
      <atlas-floating-overlay
        [title]="'Catchment list'"
        [panelWidth]="900"
        [panelHeight]="500"
        [template]="summaryStatsTemplate"
        [storageKey]="'summaryStatsOverlayState'"
        (close)="onStatsOverlayClose()"
      >
      </atlas-floating-overlay>
      

      <ng-template #summaryStatsTemplate>
        <atlas-summary-stats-grid></atlas-summary-stats-grid>
      </ng-template>
    }
  }
</div>
